import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import * as LogRocket from 'logrocket';
import { timer } from 'rxjs';
import { AccountDTO } from '../../../shared/account-dto';
import { CheckoutDTO } from '../../../shared/checkout-dto';
import { ToolbarDTO } from '../../../shared/toolbar-dto';
import { AccountService } from './account.service';
import { AlertService } from './alert.service';
import { CustomerService } from './customer.service';
import { SidebarService } from './sidebar.service';
import { SplashService } from './splash.service';
import { SpotifyService } from './spotify.service';
import { ToolbarService } from './toolbar.service';
import { TrackingService } from './tracking.service';
@Component({
  selector: 'pv-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  opened = false;
  checkoutDTO: CheckoutDTO;
  toolbarDTO: ToolbarDTO[];
  loggedIn = false;
  isHome = false;
  alerts = [];
  hasAlert = false;
  splash = false;
  cms = false;
  shopifyDownload = false; // #1358
  nonShopifyDownload = false;  // #1358

  account: AccountDTO;

  sidenavCartItem: any;
  sidenavCrossSell: any;
  @ViewChild('cnav', { static: false }) cartSnav: MatSidenav;

  constructor(
    private route: ActivatedRoute,
    private customerService: CustomerService,
    private alertService: AlertService,
    private sidebarService: SidebarService,
    private router: Router,
    private _ngZone: NgZone,
    private trackingService: TrackingService,
    private spotifyService: SpotifyService,
    private accountService: AccountService,
    private toolbarService: ToolbarService,
    private title: Title,
    private meta: Meta
  ) {
    // Subscribe to account service
    this.accountService.accountSubject
      .subscribe(account => {
        this.account = account;
        const image = (this.account.logoPhoto.thumbnail_url && this.account.logoPhoto.thumbnail_url.includes('.svg'))
          ? this.account.logo_url
          : this.account.logoPhoto.thumbnail_url

        // this.meta.addTags([
        //   { name: "description", content: this.account.seo_description || `${this.account.name} - Artists, News, Music - Shop Vinyl, Merch, Music and More` },
        //   { name: "og:type", content: "website" },
        //   { name: "og:url", content: this.account.domain },
        //   { name: "og:title", content: `${this.account.name} - Artists, News, Music - Shop Vinyl, Merch, Music and More` },
        //   { name: "og:description", content: this.account.seo_description || `${this.account.name} - Artists, News, Music - Shop Vinyl, Merch, Music and More` },
        //   { name: "og:image", content: image },
        //   { name: "twitter:image", content: image },
        //   { name: "twitter:card", content: "summary_large_image" },
        //   { name: "twitter:url", content: this.account.domain },
        //   { name: "twitter:title", content: `${this.account.name} - Artists, News, Music - Shop Vinyl, Merch, Music and More` },
        //   { name: 'twitter:text:title', content: `${this.account.name} - Artists, News, Music` },
        //   { name: "twitter:description", content: this.account.seo_description || `${this.account.name} - Artists, News, Music - Shop Vinyl, Merch, Music and More` },
        //   { name: 'twitter:site', content: account.short_name },
        //   { name: 'twitter:creator', content: account.short_name },
        // ])

        // Run Polyvinyl Scripts and Metadata
        // if (!this.customerService.checkoutDTO.customer.is_wholesale) {
        //   // Initialize Mailchimp Script
        //   if (account.id == 1) {
        //     (function (c, h, i, m, p) { m = c.createElement(h), p = c.getElementsByTagName(h)[0], m.async = 1, m.src = i, p.parentNode.insertBefore(m, p) })(document, "script", "https://chimpstatic.com/mcjs-connected/js/users/301ccb6f8cba0ba4938e01db5/39ef2ae9911221c84b373599c.js");
        //   } else if (account.id == 2) {
        //     (function (c, h, i, m, p) { (m = c.createElement(h)), (p = c.getElementsByTagName(h)[0]), (m.async = 1), (m.src = i), p.parentNode.insertBefore(m, p); })(document, "script", "https://chimpstatic.com/mcjs-connected/js/users/24e08bf1cf5410d583185b9b0/28d43dd868851d5182306dbca.js");
        //   }
        // }


        // Comment out logrocket for now
        if (this.cms && location.hostname != 'localhost' && location.pathname.includes('checkout')) {
          this._ngZone.runOutsideAngular(() => {
            timer(5000).subscribe(x => {
              // Wait 5 seconds
              LogRocket.init(`c63gil/${account.id == 1 ? 'pv' : 'dispatch-eu5br'}`)
              this.identify()
            })
          })
        }
      })

    // subscribe login
    this.loggedIn = this.customerService.loggedIn;
    this.customerService.loginSubject.subscribe(loggedIn => this.loggedIn = loggedIn)

    this.customerService.isLoggedIn()

    // subscribe to checkout
    this.checkoutDTO = this.customerService.checkoutDTO
    this.customerService.checkoutSubject
      .subscribe(checkoutDTO => {
        if (this.checkoutDTO.customer.is_wholesale != checkoutDTO.customer.is_wholesale) {
          this.checkoutDTO = checkoutDTO
        } else {
          this.checkoutDTO = checkoutDTO
        }
      })


    // Check for referrer
    // this.route.queryParams.subscribe((params) => {
    //   for (let param of Object.keys(params)) {
    //     if (param.includes('id')) {
    //       this.trackingService.track(param, params[param])
    //     }
    //   }

    //   if (params.pvr) {
    //     customerService.ref = params.pvr
    //     this.trackingService.lead(params.pvr);
    //   }
    // })

    this.router.events.subscribe(event => {

      // #1358
      if (location.pathname.includes('shopify')) {
        this.shopifyDownload = true;
      } else {
        this.shopifyDownload = false;
      }

      // #1358
      if (location.pathname.includes('download') && !location.pathname.includes('shopify')) {
        this.nonShopifyDownload = true;
      } else {
        this.nonShopifyDownload = false;
      }

      if (location.pathname.substring(0, 4) == '/cms') {
        this.cms = true;
      } else {
        this.cms = false;
      }

      // if (location.pathname.includes('wholesale')) {
      //   this.hasAlert = false;
      // } else if (!this.customerService.checkoutDTO.customer.is_wholesale) {
      //   this.hasAlert = !!this.alerts.length
      // }

      //this.splash = (location.pathname == '/splash')

      // if (event instanceof NavigationEnd) {
      //   this.trackingService.pageView(event.urlAfterRedirects, this.account ? this.account.id : 1);

      //   // isHome variable
      //   if (event.urlAfterRedirects == '/') {
      //     this.isHome = true;
      //   } else {
      //     this.isHome = false;
      //   }
      // }
    })

    // Grab the landing page
    //this.trackingService.track('landing_site', location.pathname);

    // this.alertService.getAlerts()
    //   .subscribe(alerts => {
    //     this.alerts = alerts;
    //     if (!location.pathname.includes('wholesale') && !this.customerService.checkoutDTO.customer.is_wholesale) {
    //       this.hasAlert = !!alerts.length

    //     }
    //   })

    // Subscribe to cross sells
    // this.sidebarService.itemSubject.subscribe(item => {
    //   this.sidenavCartItem = item;
    //   this.sidenavCrossSell = this.customerService.checkoutDTO.cart.crossSell;
    //   this.cartSnav.open()
    // })

    // Subscribe to toolbarDTO
    // this.toolbarDTO = this.toolbarService.toolbarDTO
    // this.toolbarService.toolbarSubject
    //   .subscribe(toolbarDTO => this.toolbarDTO = toolbarDTO);
  }

  ngOnInit() {
  }

  async identify() {
    try {
      LogRocket.identify(localStorage.getItem('pv-cms'), {
        name: localStorage.getItem('pv-cms')
      })
    } catch (e) {
      const customer = this.customerService.checkoutDTO.customer.email
      LogRocket.identify(customer ? customer : 'Guest', {
        name: customer ? customer : 'Guest'
      })
    }
  }

  getCartLength() {
    return this.checkoutDTO
      .cart
      .items
      .reduce((sum, item) => Number(item.quantity) + sum, 0)
  }

  onActivate(e) {
    document.getElementById('loader-scroll').scrollIntoView()
  }

}
